import { render, staticRenderFns } from "./OperaRhCommonPhrasesWindow.vue?vue&type=template&id=06dcbc20&scoped=true"
import script from "./OperaRhCommonPhrasesWindow.vue?vue&type=script&lang=js"
export * from "./OperaRhCommonPhrasesWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaRhCommonPhrasesWindow.vue?vue&type=style&index=0&id=06dcbc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dcbc20",
  null
  
)

export default component.exports